import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastComponent } from '@rc/shared/toast';

@Component({
	standalone: true,
	imports: [RouterModule, ToastComponent],
	selector: 'rc-root',
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
})
export class AppComponent {
	title = 'rev-cyclone';
}
